import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../../context/Auth/AuthState";
import http from "../../helpers/http";
import { dashboardURL, loginURL, proAccessURL } from "../../components/helpers/constant-words";
import config from "../../config/config";

const PersonalMagicLogin = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const base_url = config.api_url; // without trailing slash

  const auth = useAuth();

 

  const verifyToken = async (token) => {
    if (!token) {
      navigate(loginURL);
      return;
    }

    if (token) {
      const response = await http.post(
        `${base_url}/personal/magic-login`,
        { token }
      );
  
      const { token: authToken, user } = response?.data || {};

      if (!authToken) {
        navigate(loginURL, { replace: true });
        return;
      }
  
      await auth.login(authToken);
  
      const isDE = user?.user_type === "DE";
      const isProCompleted = user?.proAccessData?.status === "completed";
  
      if (isDE || isProCompleted) {
        navigate(dashboardURL, { replace: true });
      } else {
        navigate(proAccessURL, { replace: true });
      }
    }
  };

  useEffect(() => {
    const token = searchParams.get("token");
    verifyToken(token);
  }, []);

  return <></>;
};

export default PersonalMagicLogin;
